// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kvYI","colBig":"styles_colBig__3rJYw","colSmall":"styles_colSmall__2LcVk","shopifyNameWrapper":"styles_shopifyNameWrapper__3PSjb"};